import { useState, useEffect, useContext } from "react";

/*Import Bootstrap components */
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

/*Import React-icons */
import { AiOutlineEdit } from "react-icons/ai";

/*API helper import */
import { fetchGET, fetchPOST } from "../../apiHelper";

/* Import Context */
import { UserContext } from "../UserContext";

/* Import list of API endpoints */
import { mdocsObstaja, sendProjectToMDocs } from "../../listOfApi";
import { set } from "date-fns";

const MDocsBar = ({ projectSkrbnikClanica, projektID }) => {
  const [errorAddDocsApi, setErrorAddDocsApi] = useState(false);
  const [existsInMDocs, setExistsInMDocs] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const role = useContext(UserContext);

  useEffect(() => {
    fetchGETMDocsExists();
  }, [projektID]);

  //Check if project exists in MDocs
  const fetchGETMDocsExists = async (url) => {
    fetchGET(`${mdocsObstaja}/${projektID}`).then((response) => {
      if (response) {
        if (response.status === true) {
          setExistsInMDocs(true);
        }
      }
    });
  };

  //Send project to MDocs
  const handleSendProjectToMDocs = () => {
    fetchPOST(`${sendProjectToMDocs}/${projektID}`).then((responseStatus) => {
      if (responseStatus === 1) {
        setShowModal(false);
        fetchGETMDocsExists();
      } else if (responseStatus === 0) {
        setErrorAddDocsApi(true);
        setTimeout(() => {
          setErrorAddDocsApi(false);
        }, 3000);
      }
    });
  };

  return (
    <>
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        centered
        backdropClassName="static"
        size="lg"
      >
        <Modal.Header className="projekt-status-modal-header">
          <Row>
            <Col>
              <h5 className="mb-0">Vnos projekta v MDocs</h5>
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>Želite vnesti projekt v MDocs?</Col>
          </Row>
          <Row>
            <Col>
              {errorAddDocsApi && (
                <span className="text-danger my-2">
                  Prišlo je do napake pri kreiranju projekta v MDocs!
                </span>
              )}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              handleSendProjectToMDocs();
            }}
          >
            Potrdi vnos v MDocs
          </Button>

          <Button
            className="btn"
            variant="outline-primary"
            onClick={() => {
              setShowModal(false);
            }}
          >
            Prekliči
          </Button>
        </Modal.Footer>
      </Modal>
      {((role.skrbnik === true && role.clanicaID === projectSkrbnikClanica) ||
        (role.skrbnik === false && role.projekti === 2)) && (
        <Row className="project-row-status mt-2">
          {!existsInMDocs && (
            <Col className="d-inline-flex align align-items-center my-1">
              Ustvari v MDocs:
              <Button
                variant="link"
                onClick={() => setShowModal(true)}
                id="1"
                className="p-0 text-decoration-none ms-1"
              >
                <span className="d-inline-flex align-items-center link-underline link-underline-opacity-75-hover">
                  Kreiraj
                  <AiOutlineEdit className="ms-1" />
                </span>
              </Button>
            </Col>
          )}
          {existsInMDocs && (
            <Col className="d-inline-flex align align-items-center my-1 ">
              Projekt je vnešen v MDocs.
            </Col>
          )}
        </Row>
      )}
    </>
  );
};

export default MDocsBar;
